import { useEffect, useState } from "react";
import { useAuth } from "@clerk/react";
import { BellRing } from "lucide-react";
import { toast } from "sonner";
import { useApi } from "@/lib/api";
import { enablePush, pushSupported, syncPush } from "@/lib/push";

const KEY = "etm-push-asked-at";

export const PushPrompt = () => {
  const { isSignedIn } = useAuth();
  const api = useApi();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!isSignedIn || !pushSupported()) return;
    if (Notification.permission === "granted") { syncPush(api).catch(() => {}); return; }
    const last = Number(localStorage.getItem(KEY) || 0);
    if (Notification.permission === "default" && Date.now() - last > 3 * 24 * 3600 * 1000) {
      const t = setTimeout(() => setShow(true), 2500);
      return () => clearTimeout(t);
    }
  }, [isSignedIn, api]);

  const answer = async (yes) => {
    localStorage.setItem(KEY, String(Date.now()));
    setShow(false);
    if (!yes) return;
    try { await enablePush(api); toast.success("Notifications activées"); }
    catch { toast.error("Notifications non autorisées. Vous pourrez les activer dans Mon compte."); }
  };

  if (!show) return null;
  return (
    <div data-testid="push-prompt" className="fixed inset-0 z-[60] flex items-end justify-center bg-black/60 backdrop-blur-sm">
      <div className="fade-up mb-0 w-full max-w-[430px] rounded-t-[32px] border-t border-[#E6A45D]/40 bg-[#110d09] p-6 pb-10 text-center safe-bottom">
        <span className="gold-ring mx-auto flex h-14 w-14 items-center justify-center rounded-full text-[#F8C872]"><BellRing size={24} strokeWidth={1.5} /></span>
        <h2 className="mt-4 text-lg font-semibold text-[#F7F4EE]">Restez informé(e)</h2>
        <p className="mt-2 text-sm text-[#F7F4EE]/70">Confirmations, rappels la veille, nouveaux événements et messages de Carine, directement sur votre téléphone.</p>
        <button data-testid="push-prompt-accept" onClick={() => answer(true)} className="btn-gold mt-6 h-12 w-full text-sm">Activer les notifications</button>
        <button data-testid="push-prompt-decline" onClick={() => answer(false)} className="mt-3 text-xs text-[#F7F4EE]/60">Plus tard</button>
      </div>
    </div>
  );
};
